import Dialler from "@sourcewhale/shared/src/svelte/src/pages/Dialler/DiallerWebApp.svelte";
import { mount } from "svelte";

export const bindDialler = () => {
  const target = document.createElement("div");
  target.id = "dialler-root";
  document.body.appendChild(target);
  return mount(Dialler, {
    target,
  });
};
